import { PropsWithChildren, useState } from 'react';
import { Heading } from '../heading';
import { Icon, IconName } from '../icons';
import { CollapseBody, CollapseTitle, StyledCollapse } from './styled';

export type CollapseProps = PropsWithChildren<{
  title: string;
  openedByDefault?: boolean;
}>;

export function Collapse({
  title,
  children,
  ...props
}: CollapseProps): JSX.Element {
  const openedByDefault = !!props.openedByDefault;
  const [isOpen, setIsOpen] = useState<boolean>(openedByDefault);

  const onClickHandler = (): void => setIsOpen((isOpen) => !isOpen);

  return (
    <StyledCollapse>
      <CollapseTitle onClick={onClickHandler}>
        <Heading variant="h4">{title}</Heading>
        <Icon name={isOpen ? IconName.ArrowUp : IconName.ArrowDown} />
      </CollapseTitle>
      <CollapseBody isOpen={isOpen}>{children}</CollapseBody>
    </StyledCollapse>
  );
}
